// extracted by mini-css-extract-plugin
module.exports = {"two_code_wrapper":"style_two_code_wrapper__b5Nua","code_img":"style_code_img__uus9M","code_title":"style_code_title__GiEKw","code_content":"style_code_content__mkJgS"};